import React, { useState } from "react";
import MilesPointsLeaderboardSearchSection from "./MilesPointsLeaderboardSearchSection";
import MilesLeaderBoardTopRankCard from "./MilesLeaderBoardTopRankCard";
import MilesLeaderboardRankCard from "./MilesLeaderboardRankCard";
import CommonPaginationSection from "../../components/common/CommonPaginationSection";

function MilesPointsLeaderboardSection() {
  const [search, setSearch] = useState("");
  const [range, setRange] = useState("This Week");
  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 10,
    total: 10,
  });

  return (
    <div className="w-full flex flex-col">
      <MilesPointsLeaderboardSearchSection
        search={search}
        setRange={setRange}
        setSearch={setSearch}
        range={range}
      />
      <div className="w-full flex items-center justify-between mt-4">
        {[...Array(3)].map((_, index) => (
          <MilesLeaderBoardTopRankCard key={index} />
        ))}
      </div>
      <div className="w-full flex flex-col items-center mt-4 gap-3">
        {[...Array(10)].map((_, index) => (
          <MilesLeaderboardRankCard key={index} />
        ))}
      </div>
      <CommonPaginationSection
        page={pagination.page}
        perPage={pagination.perPage}
        total={pagination.total}
        callback={(page, perPage) => {
          setPagination({
            ...pagination,
            page,
            perPage,
          });
        }}
      />
    </div>
  );
}

export default MilesPointsLeaderboardSection;
